var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;stroke:#b7b7b7;stroke-miterlimit:10;stroke-width:0.25px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.76,5.29a10.88,10.88,0,0,0-1.08-.74.74.74,0,0,1-.19-1.3A27.65,27.65,0,0,1,9.36,1.52c.55-.28,1.09.22,1.05.85a1.7,1.7,0,0,0,.17.83c.34.64.74,1.25,1.12,1.87.27.43.45.87,1.1.95A.72.72,0,0,1,13,7.32c-.91.61-1.86,1.17-2.83,1.69a.77.77,0,0,1-1.09-.67,13.92,13.92,0,0,0-.41-1.55C6.87,8,5.23,9.09,3.58,10.17a5.25,5.25,0,0,1-.68.4,1,1,0,0,1-1.31-.4.93.93,0,0,1,.23-1.3,5,5,0,0,1,.72-.47L7.66,5.55ZM9.59,7.55l2.19-1.33L9.84,3,7.65,4.37ZM8.24,6.45V6.24c-.19,0-.42-.15-.56-.07-1.8,1-3.59,1.95-5.36,3-.18.1-.19.5-.27.75.27,0,.62.21.79.1C4.66,8.84,6.45,7.64,8.24,6.45ZM7,4.09A1,1,0,0,0,7.19,4C8,3.49,8.88,3,9.71,2.46c.08,0,.07-.24.11-.37-.12,0-.27-.1-.35-.06q-1.31.75-2.58,1.53a.4.4,0,0,0-.12.34C6.77,4,6.91,4,7,4.09Zm5.88,2.73,0-.21c-.17,0-.37-.1-.49,0C11.49,7,10.68,7.51,9.89,8c-.11.07-.15.27-.22.41.18,0,.4.12.52.05C11,8,11.75,7.52,12.53,7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.28,13.56C7.18,12.19,7.35,12,8.67,12h3.5c1.31,0,1.48.19,1.39,1.55ZM13,13l.09-.19c-.18-.1-.35-.29-.53-.29-1.45,0-2.9,0-4.34,0-.18,0-.36.19-.54.29L7.8,13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaw);
export default __webpack_public_path__ + "static/media/law.decc039d823cb8f947f6d865c5b03a95.svg";
export { ForwardRef as ReactComponent };